'use client';

import { useTranslation as _useTranslation } from '@crehana/i18n';

import { PAGE_KEY } from '../constants';

export const useTranslation = () => {
  return _useTranslation(PAGE_KEY);
};
